<template>
  <div class="orderwrap">
    <van-search
      v-model="searchKeyWord"
      shape="round"
      left-icon="https://img.zai-art.com/zaiart/saas/image/md/112644a0780989204764b3ee98418c2e.png"
      placeholder="请输入搜索关键词"
      @search="onRefresh"
      @clear="onRefresh"
    />
    <van-tabs
      v-if="headerTabs && headerTabs.length"
      :swipe-threshold="headerTabs.length"
      @click="toggle"
      v-model="selectedState"
      sticky
    >
      <van-tab
        v-for="(item, inx) in headerTabs"
        :title="item.name"
        :key="inx"
        :name="item.tradeState"
      >
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="loadMore"
            style="min-height: calc(100vh - 44px)"
            :style="{ paddingTop: finished && list.length <= 0 ? '45vh' : '' }"
          >
            <div
              v-for="(item, index) in list"
              :key="index"
              @click="opendetail(item)"
              class="item-content"
            >
              <div class="header">
                <div class="header-name-sub">
                  <span class="header-id">订单编号 {{ item.id }}</span>
                  <span
                    class="header-status"
                    :style="item.tradeState < 10 ? 'color:#FF3E3E' : ''"
                    >{{ getOrderTradeStateStr(item.tradeState) }}</span
                  >
                </div>
              </div>
              <template>
                <div
                  class="item-content-wrapper"
                  v-for="(trade, ind) in item.tradeItemList"
                  :key="ind"
                >
                  <order-item-content :item="trade"></order-item-content>
                  <div class="order-content-space"></div>
                </div>
              </template>
              <div class="footer">
                <p>
                  <span>总计：</span
                  ><span class="footer-price">
                    {{ item.mainCurrency ? item.mainCurrency.mark : '¥'
                    }}{{ getPrice(item.payAmount) }}</span
                  >
                </p>
                <div class="func-bar">
                  <div class="btn" @click.stop="clickEdit(item)" v-if="false">修改</div>
                  <div class="btn" v-if="item.tradeState == 3" @click.stop="clickSend(item)">
                    发货
                  </div>
                  <div
                    class="btn"
                    v-if="
                      item.payState === 60 && //支付成功
                      item.payAmount > 0 && //支付金额大于0
                        (item.tradeType != 21 ||
                          !item.tradeTicket ||
                          item.tradeTicket.ticketState == 0) // 不是电子票类型 或者没有电子票 或者未核销
                    "
                    @click.stop="clickRefund(item)"
                  >
                    退款
                  </div>
                  <div
                    class="btn"
                    v-if="item.tradeState == 40 || item.tradeState == 0"
                    @click.stop="clickClose(item)"
                  >
                    关闭订单
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <refund-dialog
        v-model="refundObj.showDialog"
        :order="refundObj.selectOrder"
        @refund-success="updateOrder"
        :type="35"
      ></refund-dialog>
      <send-dialog
        v-model="sendObj.showDialog"
        :order="sendObj.selectOrder"
        @send-success="updateOrder"
        :type="35"
      ></send-dialog>
      <edit-dialog
        v-model="editObj.showDialog"
        :order="editObj.selectOrder"
        :type="35"
        @edit-success="updateOrder"
      ></edit-dialog>
    </van-tabs>
  </div>
</template>

<script>
import { List, PullRefresh, Tab, Tabs, Dialog, Toast } from 'vant';
import { formatDateTime } from '@/utils/index';
import { getOrderTradeStateStr } from '@/views/order/orderTool';
import orderItemContent from '@/views/order/components/orderItemContent';
import { getOrderList, closeOrder } from '@/api/order';
import mixinRefund from '@/views/order/mixin/refund';
import mixinSend from '@/views/order/mixin/send';
import mixinEdit from '@/views/order/mixin/edit';
//
export default {
  components: {
    vanList: List,
    vanPullRefresh: PullRefresh,
    vanTab: Tab,
    vanTabs: Tabs,
    orderItemContent,
  },
  mixins: [mixinRefund, mixinSend, mixinEdit],
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      activeName: '',
      searchKeyWord: null,
      headerTabs: [
        {
          name: '全部',
          tradeState: '',
        },
        {
          name: '待付款',
          tradeState: '0',
        },
        {
          name: '待发货',
          tradeState: '3',
        },
        {
          name: '待收货',
          tradeState: '6',
        },
        {
          name: '完成',
          tradeState: '20',
        },
        {
          name: '已退款',
          tradeState: '40',
        },
      ],
      selectedState: '',
      showCancelPay: false,
      page: {
        index: '',
        size: 10,
      },
    };
  },
  created() {
    let active = this.$route.query.active || '';
    this.selectedState = active;
  },
  methods: {
    formatDateTime,
    getOrderTradeStateStr,
    init() {
      this.loading = true;
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '...',
      });
      getOrderList({
        tradeState: this.selectedState,
        page: this.page,
        goodName: this.searchKeyWord,
      })
        .then(res => {
          let tmpList = res.data.data || [];
          let list = this.list || [];
          if (this.refreshing) {
            list = tmpList;
            this.refreshing = false;
          } else if (tmpList.length) {
            list = [...list, ...tmpList];
          } else {
            this.finished = true;
          }
          this.loading = false;
          this.list = list;
          this.page = res.data.next;
          Toast.clear();
        })
        .catch(error => {
          Toast.clear();
        });
    },
    toggle() {
      this.list = [];
      this.loading = true; // 下拉加载中
      this.finished = false; // 下拉结束
      this.page = { index: '', size: 10 };
      if (this.loading) {
        this.init();
      }
    },

    loadMore() {
      this.loading = true;
      this.init();
    },
    onRefresh() {
      // 清空列表数据
      this.refreshing = true;
      this.finished = false;
      this.loading = true;
      this.page = { index: '', size: 10 };
      this.init();
    },
    getPrice(value) {
      value = value || 0;
      return value.toFixed(2);
    },

    clickClose(item) {
      let self = this;
      Dialog.confirm({
        title: '操作提示',
        message: '确认要关闭订单么？',
      })
        .then(() => {
          closeOrder({
            id: item.id,
          }).then(res => {
            self.updateOrder(res.data);
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    opendetail(item) {
      this.$router.push(`/order/good/detail/${item.id}`);
    },
    updateOrder(order) {
      this.list.forEach(item => {
        if (item.id == order.id) {
          Object.assign(item, order);
        }
      });
    },
  },
};
</script>
<style scoped src="../order-list.css" scoped></style>
<style lang="less">
.orderwrap .van-field__left-icon .van-icon {
  line-height: initial;
}
</style>
